module.exports = __webpack_public_path__ + "img/bar-2.53a5cb60.svg";